import { Flex } from '@components';
import { styled } from '@mui/material';

export const CategoryContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(8),
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.spacing(5),
  padding: theme.spacing(10, 8),
}));

export const CategoryHeaderContainer = styled(Flex)(({ theme }) => ({
  width: '100%',
  justifyContent: 'space-between',
  margin: theme.spacing(3, 5),
}));

export const NewItemFormContainer = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(12, 16),
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(8),
  gap: theme.spacing(12),
}));
